import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://chatpanel.my.id/api';

function Login({ setUser }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loginLogo, setLoginLogo] = useState(null);

    useEffect(() => {
        // Fetch login logo
        fetch('/api/settings/logos')
            .then(res => res.json())
            .then(data => {
                if (data.login_logo) {
                    setLoginLogo(data.login_logo);
                }
            })
            .catch(err => console.error('Error fetching logo:', err));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axios.post(`${API_URL}/auth/login`, {
                username,
                password
            });

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            setUser(response.data.user);
        } catch (err) {
            setError(err.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    const inputWrapperStyle = {
        position: 'relative',
        marginBottom: '20px'
    };

    const iconStyle = {
        position: 'absolute',
        left: '14px',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '20px',
        pointerEvents: 'none',
        opacity: 0.6
    };

    const inputStyle = {
        width: '100%',
        padding: '12px 12px 12px 45px',
        border: '2px solid #e0e0e0',
        borderRadius: '6px',
        fontSize: '16px',
        boxSizing: 'border-box',
        transition: 'border-color 0.3s'
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #8D1E3A 0%, #DB4333 100%)' }}>
            <div style={{ background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)', width: '100%', maxWidth: '400px' }}>
                {loginLogo ? (
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <img src={loginLogo} alt="Logo" style={{ maxHeight: '62px', maxWidth: '100%' }} />
                    </div>
                ) : (
                    <h1 style={{ textAlign: 'center', marginBottom: '8px', fontSize: '28px' }}>Chat Panel</h1>
                )}
                <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>Admin Chat Panel</p>
                
                {error && (
                    <div style={{ background: '#fee', border: '1px solid #fcc', color: '#c33', padding: '12px', borderRadius: '6px', marginBottom: '20px' }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Username</label>
                        <div style={inputWrapperStyle}>
                            <span style={iconStyle}>👤</span>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                style={inputStyle}
                                onFocus={(e) => e.target.style.borderColor = '#8D1E3A'}
                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                required
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Password</label>
                        <div style={inputWrapperStyle}>
                            <span style={iconStyle}>🔒</span>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={inputStyle}
                                onFocus={(e) => e.target.style.borderColor = '#8D1E3A'}
                                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{ 
                            width: '100%', 
                            padding: '14px', 
                            background: 'linear-gradient(135deg, #8D1E3A 0%, #DB4333 100%)', 
                            color: 'white', 
                            border: 'none', 
                            borderRadius: '6px', 
                            fontSize: '16px', 
                            fontWeight: '600', 
                            cursor: loading ? 'not-allowed' : 'pointer', 
                            opacity: loading ? 0.7 : 1,
                            boxSizing: 'border-box',
                            transition: 'transform 0.2s'
                        }}
                        onMouseOver={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>

                    <p style={{ textAlign: 'center', marginTop: '20px', color: '#999', fontSize: '14px' }}>
                        Default: admin / admin123
                    </p>
                </form>
            </div>
        </div>
    );
}

export default Login;
